export default __webpack_public_path__ + "static/O0135-e7b2e2f8e5b1c1c5e6d6580cb262267e.png";